import axios from 'axios';
import get from 'lodash/get';
import AccessKey from './utils/getSetAccessKey';
import {createClientStateFromResponse} from './utils/createClientStateFromResponse';
import {createOrdersFromResponse} from './utils/createOrdersFromResponse';
import {IOrder} from './common/types';

//const serverLink = '/rest/api.php';
const serverLink = 'https://billing.biokurs.com.ua/rest/api.php';

const createPost = (data: object) => axios.post(serverLink, data);

export const loginClient = async (login?: string, password?: string) => {

  const dataToSend = {
    login,
    pwd: password,
    action: 'login',
    access_key: "dfvmmkl403lp1-3okk34mmd",
  };

  const result = await createPost(dataToSend);
  const error = get(result, 'data.error', null);

  if (error) return new Error('Не правильний логін чи пароль!');

  const client = get(result, 'data.client', null);


  if (client) {
    AccessKey.set(client.access_key);
    return createClientStateFromResponse(client);
  }

  return new Error('Не правильний логін чи пароль!');
};

export const getClient = async () => {

  const dataToSend = {
    access_key: AccessKey.get(),
    action: 'get_client'
  };

  const result = await createPost(dataToSend);
  const error = get(result, 'data.error', null);

  if (error) return new Error('Не правильний логін чи пароль!');

  const client = get(result, 'data.client', null);

  if (client) {
    return createClientStateFromResponse(client);
  }

  return new Error('Не правильний логін чи пароль!');
};

export const getOrders = async () => {
  const accessKey = AccessKey.get();
  const data = {
    access_key: accessKey,
    action: 'get_orders'
  };

  const result = await createPost(data);

  const error = get(result, 'data.error', null);
  if (error) return new Error('Не правильний логін чи пароль!');

  const orders = get(result, 'data.orders', []);
  const ordersFormatted = createOrdersFromResponse(orders);
  const sortByDate = (a: IOrder, b: IOrder) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);

    return Number(dateB) - Number(dateA);
  };

  return ordersFormatted.sort(sortByDate);
};


export const getOrderResult = async (orderId: number) => {

  const accessKey = AccessKey.get();
  const data = {
    access_key: accessKey,
    idorder: orderId,
    action: 'get_result'
  };

  const result = await axios({
    url: serverLink,
    method: 'POST',
    responseType: 'blob',
    data,
  });

  const error = get(result, 'data.error', null);
  if (error) return new Error('Щось пішло не так!');

  return result.data;

};
